import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tooltip } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';
import { regFenToYuan } from '@/util/money';
import { QuestionCircleOutlined } from '@ant-design/icons';

function TableList(props) {

    const _renderActionCell = (key, item) => {
        const { tableAction } = props;
        return (
            <div className={styles.action}>
                {/* <div className={styles.item} onClick={() => tableAction('detail', item)}>详情</div> */}
                <div className={styles.item} onClick={() => tableAction('accountDetail', item)}>账户明细</div>
                <div className={styles.item} onClick={() => tableAction('cashRecord', item)}>提现记录</div>
            </div>
        );
    };

    const renderPrice = (val) => {
        if(val == undefined){
            return '-'
        }
        return '￥' + regFenToYuan(val);
    };

    const columns = [
        {
            title: '小运力公司信息',
            dataIndex: 'transportName',
            key: 'transportName',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '开户时间',
            dataIndex: 'openTime',
            key: 'openTime',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '账户id',
            dataIndex: 'walletId',
            key: 'walletId',
            width: '100px',
            align: 'center',
            render: tooltip
        },
        {
            title: '账户总额',
            dataIndex: 'totalBalance',
            key: 'totalBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '可用金额',
            dataIndex: 'balance',
            key: 'balance',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: () => {
                return (
                    <div className={styles.tableTooltip}>
                        <div className={styles.tableTitle}>待结算金额</div>
                        <Tooltip title={() => {
                            return (
                                <div>
                                    <div>说明</div>
                                    <div>1、待结算金额为平台统计数据</div>
                                    <div>2、其他数据由合作方(银联)提供</div>
                                </div>
                            )
                        }}>
                            <QuestionCircleOutlined style={{fontSize:'14px'}} />
                        </Tooltip>
                    </div>
                )
            },
            dataIndex: 'expectedBalance',
            key: 'expectedBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '冻结金额',
            dataIndex: 'blockBalance',
            key: 'blockBalance',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '账户状态',
            dataIndex: 'statusDec',
            key: 'statusDec',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '160px',
            align: 'center',
            fixed: 'right',
            render: (text, item) => _renderActionCell(item.id, item)
        }
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={r => r.id}
                columns={columns}
                dataSource={props.renderData.dataList || []}
                pagination={false}
                scroll={{ y: true }}
            />
            <XPagination
                resultTotal={props.renderData.resultTotal}
                pageSize={props.renderData.pageSize}
                pageNum={props.renderData.pageNum}
                onChange={props.paginationChange}
            />
        </div>
    );
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;